import * as bootstrap from 'bootstrap';
import jsKit from '../../shared/modules/jsKit';
import { swipers } from '../../shared/modules/swipers';

const getBootstrap = () => bootstrap;

export const loadProductInfo = async (event) => {
  event.preventDefault();

  const productId = event.delegateTarget.dataset.jsLoadProductInfo;
  const modal = document.querySelector('#gratis-product-modal');
  const modalContent = modal?.querySelector('.modal-content');
  const bootstrap = getBootstrap();

  if (!productId || !modal || !modalContent || !bootstrap) {
    return;
  }

  jsKit.setLoading(event.delegateTarget, true);
  modalContent.innerHTML = '';

  try {
    const response = await fetch(`/product/info/${encodeURIComponent(productId)}`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error(`Product info request failed with status ${response.status}`);
    }

    modalContent.innerHTML = await response.text();
    swipers.swiperGratisProductPhotosInit(modal);
    jsKit.initTooltip(modal.querySelectorAll('[data-bs-toggle="tooltip"]'));

    bootstrap.Modal.getOrCreateInstance(modal).show();
    modal.addEventListener('hidden.bs.modal', () => {
      modalContent.innerHTML = '';
    }, { once: true });
  } catch (error) {
    console.error(error);
    jsKit.showNotificationsPanel('Nie udało się wczytać informacji o produkcie.', 'error');
  } finally {
    jsKit.setLoading(event.delegateTarget, false);
  }
};
